/** Mirrors backend `ScheduledCallConsts` bounds checked by `ScheduledCallSettingsAppService` (K-077). */
export const SCHEDULED_CALL_SETTINGS_LIMITS = {
  minMaxAssignmentAttempts: 1,
  maxMaxAssignmentAttempts: 100,
  minReassignmentCooldownMinutes: 1,
  maxReassignmentCooldownMinutes: 1440,
  minAssignmentBcwSeconds: 10,
  maxAssignmentBcwSeconds: 600,
  defaultAssignmentBcwSeconds: 60,
} as const;
